import { Card, Layout, Menu } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import AppHeader from "./header";
import AppFooter from "./footer";
import { ChevronRight, ChevronUp, DatabaseIcon, Gauge, LogsIcon, Network, SettingsIcon, UserRound } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { REACT_APP_ENV, REACT_APP_URL } from "../constants";
import { UseLogout } from "../common/UseLogout";
import { AppstoreOutlined, CloudServerOutlined, ContainerOutlined, ControlOutlined, CreditCardOutlined, DashboardOutlined, DesktopOutlined, IdcardOutlined, KeyOutlined, LogoutOutlined, PullRequestOutlined, RadiusSettingOutlined, RotateRightOutlined, SettingOutlined, SolutionOutlined } from "@ant-design/icons";
// AI Agent (co-pilot) hidden from the UI — uncomment to restore.
// import AIAgent from "../components/policyEngine/AIAgent/AIAgent";
import { getLocalStorage } from "../utils/helpers";
import SideBar from "./sideBar";
const { Sider, Content } = Layout;
const { SubMenu } = Menu;

function LayoutView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userRole, setUserRole] = useState(() => getLocalStorage("UserRole"));
  const [openKeys, setOpenKeys] = useState([]);
  const [mode, setMode] = useState(localStorage.getItem("currentMode") || "pam");
  const [mainMenuSelectedValues, setMainMenuSelectedValues] = useState([]);
  const ENVIRONMENT = REACT_APP_ENV;
  const logOutUser = UseLogout();
  const currentPath = location.pathname;
  // Settings is shared by every MFA mode and opened from the account menu, so
  // it (and every page under it) is shown without the product's sidebar.
  const isSettings = currentPath === "/pam/settings" || currentPath.startsWith("/pam/settings/");

  // AI Agent visibility state — only used by the hidden co-pilot.
  // const [visible, setVisible] = useState(() => {
  //   const savedState = sessionStorage.getItem("authnull_copilot_visible");
  //   return savedState === "true";
  // });

  useEffect(() => {
    const onStorageChange = () => {
      setUserRole(getLocalStorage("UserRole"));
    };

    window.addEventListener("storage", onStorageChange);
    return () => window.removeEventListener("storage", onStorageChange);
  }, []);

  // useEffect(() => {
  //   try {
  //     sessionStorage.setItem("authnull_copilot_visible", visible);
  //   } catch (error) {
  //     console.error("Could not save co-pilot visibility to sessionStorage", error);
  //   }
  // }, [visible]);

  useEffect(() => {
    const stored = getLocalStorage("currentMode");
    if (typeof stored === "string" && stored.startsWith("mfa_")) return;
    const modeFromPath = currentPath.split("/")[1] || "pam";
    setMode(modeFromPath);
  }, [currentPath]);

  useEffect(() => {
    const cleanedPath = currentPath.replace(/^\/+/, "");
    if (cleanedPath.startsWith("pam/directory")) {
      setMainMenuSelectedValues(["pam/directory"]);
    } else setMainMenuSelectedValues([cleanedPath]);
  }, [currentPath]);

  useEffect(() => {
    if (currentPath.startsWith("/pam/databases")) {
      setOpenKeys(["databases"]);
    } else if (currentPath.startsWith("/pam/endpointsUsers") || currentPath.startsWith("/pam/endpointGroups") || currentPath.startsWith("/pam/endpoint")) {
      setOpenKeys(["endpoint"]);
    } else if (currentPath.startsWith("/pam/jumpServer")) {
      setOpenKeys(["jumpServer"]);
    } else if (currentPath.startsWith("/pam/settings/users")) {
      // Users & Access lives under the Directory group in directory mode; the
      // key is inert in modes whose nav has no such group.
      setOpenKeys(["/directory/users"]);
    } else if (currentPath.startsWith("/pam/users") || currentPath.startsWith("/pam/entraUsers") || currentPath.startsWith("/pam/directory")) {
      setOpenKeys(["identities"]);
    } else {
      setOpenKeys([]);
    }
  }, [currentPath]);

  const handleNavigation = (path) => {
    if (localStorage.getItem("token")) {
      navigate(path);
    } else {
      logOutUser();
    }
  };

  const onOpenChange = (keys) => {
    if (keys.length > 1) {
      setOpenKeys([keys.pop()]);
    } else {
      setOpenKeys(keys);
    }
  };

  return (
    <>
      <Layout className="app-container">
        <AppHeader />
        <Layout style={{ flex: 1, minHeight: 0 }} hasSider={!isSettings}>
          {!isSettings && <SideBar />}
          <Content className="app-content" style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
            <Card className="signin-card" classNames={{ body: "app-card-content !space-y-4" }}>
              <Outlet />
            </Card>
            <AppFooter />
          </Content>
        </Layout>
        {/* <AIAgent visible={visible} setVisible={setVisible} /> */}
      </Layout>
    </>
  );
}

export default LayoutView;
